import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { sha256 } from 'js-sha256';
import {  FnLocalStorageService, FnToasterService } from 'foundation';
import { Observable, catchError, of, tap } from 'rxjs';
import { PosLoginResponseService } from './pos.login.response.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PosHttpService extends FnLocalStorageService {
  public headers: HttpHeaders = new HttpHeaders();
  private baseURL = environment.API_BASE_URL;
  constructor(
    private http: HttpClient,
    private loginRespSvcs:PosLoginResponseService,
    private router:Router,
    private toastr:FnToasterService,
  ) {
    super();
   /*  this.baseURL =  window.location.origin+"/"+window.location.pathname.split("/")[1];
	 console.log("baseURL",this.baseURL); */
  }

  private buildUrl(endpoint: string): string {
    return `${this.baseURL}/${endpoint}`;
}
  // public url(): string {
  //   return `${environment.API_LOCAL_URL}`;
  // }

  public appendHeaders(options: any, xSigKey: any): any {
    this.setToken(xSigKey);
    if (!options) {
      options = {};
    }
    if (options.headers) {
      for (const key in options.headers) {
       this.headers= this.headers.append(key, options.headers[key])
      }
    }
    options['headers'] = this.headers;
    return options;
  }

  public setToken(xSigKey: string): void {
    if(!xSigKey){
      xSigKey = `${environment.DEFAULT_SIG_KEY}`;
    }
    const randomVal = Math.random();
    const xSignature = `${randomVal}:${xSigKey}`;
    const hash2 = sha256(xSignature);
    this.headers = this.headers.set('X-Api-Key', `${randomVal}`);
    this.headers = this.headers.set('X-Request-Signature', `${hash2}`);
    
  }

  authPost(url:string,xSigKey:any,body:object | string):Observable<any>{
 
    const fullUrl = this.buildUrl(url);
    const apiRequest = this.appendHeaders({},xSigKey);
    apiRequest['headers']=  apiRequest['headers'].append(environment.AUTHORIZATION,this.loginRespSvcs.authToken);
    return this.http.post(fullUrl,body, apiRequest).pipe(
      tap(r => {
        return r;
      }),
      catchError((errorResp: Error): Observable<any> => {
         return this.handleError(errorResp);
        // return of({"isError":true,"message":errorResp});
      })
    );
	}

  unauthPost(url:string,xSigKey:any,body:object|string):Observable<any>{
    const fullUrl = this.buildUrl(url);
    const apiRequest = this.appendHeaders({},xSigKey);
    return this.http.post(fullUrl,body, apiRequest).pipe(
      tap(r => {
        return r;
      }),
      catchError((errorResp: Error): Observable<any> => {
         return this.handleError(errorResp);
      })
    );
  }

  handleError(errorResp:any){
    if(errorResp.error.data.code == '401'){
      this.toastr.error(errorResp.error.data.message);
      this.router.navigateByUrl('/login');
      return of({isError:false,message:errorResp.error.data.message});
    }else{
     // this.toastr.error(errorResp.error.message);
      return of({isError:true,message:errorResp.error.data.message});
    }
  }

  authGet(url:string,xSigKey = {}): Observable<any> {
    const fullUrl = this.buildUrl(url);
    const apiRequest = this.appendHeaders({},xSigKey);
    apiRequest['headers']=  apiRequest['headers'].append(environment.AUTHORIZATION,this.loginRespSvcs.authToken);
    return this.http.get(fullUrl, apiRequest).pipe(
      tap(r => {
        return r;
      }),
      catchError((errorResp: Error): Observable<any> => {
        return this.handleError(errorResp);
      })
    );
	}

  authPut(url:string,xSigKey:any,body:object | string): Observable<any>{
    const fullUrl = this.buildUrl(url);
    const apiRequest = this.appendHeaders({},xSigKey);
    apiRequest['headers']=  apiRequest['headers'].append(environment.AUTHORIZATION,this.loginRespSvcs.authToken);
    return this.http.put(fullUrl,body, apiRequest).pipe(
      tap(r => {
        return r;
      }),
      catchError((errorResp: Error): Observable<any> => {
        return this.handleError(errorResp);
      })
    );
	}

  authDelete(url:string,xSigKey:any): Observable<any> {
    const fullUrl = this.buildUrl(url);
    const apiRequest = this.appendHeaders({},xSigKey);
    apiRequest['headers']= apiRequest['headers'].append(environment.AUTHORIZATION,this.loginRespSvcs.authToken);
    return this.http.delete(fullUrl, apiRequest).pipe(
      tap(r => {
        return r;
      }),
      catchError((errorResp: Error): Observable<any> => {
        return this.handleError(errorResp);
      })
    );
	}

  authDeleteWithBody(url: string, xSigKey: any, body: object | string): Observable<any> {
    const fullUrl = this.buildUrl(url);
    // Append headers with the authorization token
    const apiRequest = this.appendHeaders({}, xSigKey);
    apiRequest['headers'] = apiRequest['headers'].append(environment.AUTHORIZATION, this.loginRespSvcs.authToken);

    // Create a new HttpRequest with method DELETE, url, body, and options (including headers)
    const req = new HttpRequest('DELETE', fullUrl, body, {
        headers: apiRequest['headers'],
        reportProgress: false, // Set to true if you want progress updates
        responseType: 'json'   // Change as needed, e.g., 'text' if the response is plain text
    });

    return this.http.request(req).pipe(
        tap(r => {
            return r;
        }),
        catchError((errorResp: Error): Observable<any> => {
            return this.handleError(errorResp);
        })
    );
}



}
